import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(default)/template.tsx");
